<a
  [routerLink]="['/team', user().escuderia, user().agencia, user().uid]"
  class="grid h-full cursor-pointer items-center gap-2 rounded-xl bg-gray-800 p-4 text-center text-white shadow-lg transition-all duration-200 hover:scale-[1.02] hover:cursor-pointer hover:shadow-[0px_4px_10px_0px_#00000090] lg:gap-x-4 lg:gap-y-1 lg:text-left">
  <h2 class="name font-barlow line-clamp-2 font-bold tracking-[0] text-gray-100 uppercase italic">
    {{ user().name }}
  </h2>

  <div class="avatar relative mx-auto h-32 w-32 shrink-0 overflow-hidden rounded-md">
    <frame-avatar [data]="frameAvatar()!"></frame-avatar>
  </div>

  <div>
    @if (user().cargo; as cargo) {
      <p class="job text-balance">{{ cargo }}</p>
    }
    @if (user().agenciaName; as agenciaName) {
      <p class="job text-balance capitalize">{{ agenciaName }}</p>
    }
  </div>

  <div class="score mt-auto ml-auto">
    <score [score]="score()"></score>
  </div>
</a>
